// extracted by mini-css-extract-plugin
export default {"slide":"projectsSlide_slide__ONnhu","text":"projectsSlide_text__dxr+x","logo":"projectsSlide_logo__W+loD"};